export type NotificationPermissionState = 'default' | 'granted' | 'denied';

const isSupported = () =>
  typeof window !== 'undefined' &&
  'Notification' in window &&
  typeof Notification === 'function';

export const requestNotificationPermission = async (): Promise<NotificationPermissionState> => {
  if (!isSupported()) {
    return 'denied';
  }
  try {
    const result = await Notification.requestPermission();
    return result;
  } catch (error) {
    console.warn('Notification permission request failed', error);
    return 'denied';
  }
};

export const showNotification = async (
  title: string,
  options?: NotificationOptions,
): Promise<void> => {
  if (!isSupported()) {
    return;
  }

  if (Notification.permission !== 'granted') {
    return;
  }

  try {
    const registration = await navigator.serviceWorker?.ready;
    if (registration && typeof registration.showNotification === 'function') {
      await registration.showNotification(title, options);
      return;
    }
  } catch (error) {
    console.warn('Service worker notification failed, falling back', error);
  }

  // Fallback to direct Notification
  try {
    // eslint-disable-next-line no-new
    new Notification(title, options);
  } catch (error) {
    console.warn('Notification fallback failed', error);
  }
};
